import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import settings from "../../../../utils/settings";
import defaultErrorHandler from "../../../../actions/global/default-error-handler";

const URL = `${settings.iPayUrl}api/admin/penalty`;

const PenaltyModal = ({
                        userId,
                        onCancel
                      }) => {
  const [amount, setAmount] = useState(0);
  const [comment, setComment] = useState("");

  const handleSubmit = async () => {
    await axios.post(URL, {
      walletId: userId,
      amount,
      comment
    })
      .then(() => {
        toast("Penalty added successfully", {
          type: toast.TYPE.SUCCESS,
        });
      })
      .catch(error => {
        defaultErrorHandler(error, "error");
      })
      .finally(() => onCancel(true));
  };


  return (
    <div>
      <div className="form-group">
        <label>Amount</label>
        <input
          min={0}
          type="number"
          className="form-control"
          name="amount"
          value={amount}
          onChange={ev => setAmount(Number(ev.target.value))}
        />
      </div>
      <div className="form-group">
        <label>Comment</label>
        <textarea
          className="form-control form-control-sm"
          value={comment}
          onChange={ev => setComment(ev.target.value)}
          placeholder="Description"
        />
      </div>

      <div className="d-flex justify-content-between">
        <button
          className="btn btn-danger"
          onClick={() => onCancel()}
        >
          Cancel
        </button>
        <button
          className="btn btn-success"
          onClick={handleSubmit}
          disabled={amount <= 0 || comment === ""}
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default PenaltyModal;



// WEBPACK FOOTER //
// ./src/views/pages/users/penalties/penalty-modal.js